import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Classes } from '@blueprintjs/core';
import Text from './Text';
const Label = props => /*#__PURE__*/React.createElement(Text, _extends({
  className: Classes.LABEL
}, props));
export default Label;